import { env } from "@env/environment";
import { HttpClient } from "@angular/common/http";
import { UnitaDocumentariaVO } from "../vo/unita-documentariaVO";
import { Observable, throwError as observableThrowError } from "rxjs";
import { BaseResponseVO } from "../vo/base-responseVO";
import { BaseResponseDTO } from "../dto/base-responseDTO";
import { map, catchError } from "rxjs/operators";
import { MapperBaseResponse } from "../mapper/mapper-baseresponse";
import { Injectable } from "@angular/core";
import { MapperUnitaDocumentaria } from "../mapper/mapper-unita-documentaria";
import { UnitaDocumentarieGescorDTO } from "../dto/gescor/unita-documentarie-gescorDTO";
import { PaginazioneVO } from "../vo/paginazioneVO";
import { ListaPaginataVO } from "../vo/lista-paginata-vo";
import { AttribuzioneVO } from "../vo/gescor/attribuzioneVO";
import { AttribuzioneDTO } from "../dto/gescor/attribuzioneDTO";
import { ResultListDTO } from "../dto/result-listDTO";

import { ModaleErroreStore } from "../store/modale-errore.store";
import { CorrispondenzaArrivoDTO } from "../dto/gescor/corrispondenza-arrivoDTO";
import { CorrispondenzaArrivoVO } from "../vo/gescor/corrispondenza-arrivoVO";
import { MapperAttribuzioni } from "../mapper/gescor/mapper-attribuzioni";
import { MapperCorrispondenzaArrivo } from "../mapper/gescor/mapper-corrispondenza-arrivo";
import { FiltroRicercaUnitaDocumentarieVO } from "../vo/gescor/filtro-ricerca-unita-documentarieVO";
import { CorrispondenzaPartenzaDTO } from "../dto/gescor/corrispondenza-partenzaDTO";
import { CorrispondenzeGescorVO } from "../vo/gescor/corrispondenze-gescorVO";
import { MetadatiCorrispondenzaArrivoVO } from "../vo/gescor/metadati-corrispondenza-arrivoVO";
import { MapperMetaDatiCorrispondenza } from "../mapper/gescor/mapper-metadati-corrispondenza";
import { MapperMetaDatiProtocolloGescor } from "../mapper/gescor/mapper-metadati-protocollo-gescor";
import { CorrispondenzaPartenzaVO } from "../vo/gescor/corrispondenza-partenzaVO";
import { MapperCorrispondenzaPartenza } from "../mapper/gescor/mapper-corrispondenza-partenza";
import { AssegnazioneDipendenteDTO } from "../dto/gescor/assegnazione-dipendenteDTO";
import { CopiaConformeDTO } from "../dto/gescor/copia-conformeDTO";
import { MetadatiProtocolloDTO } from "../dto/metadati-protocolloDTO";
import { ClassificaVO } from "../vo/classificaVO";
import { MetadatiProtocolloEstesiDTO } from "../dto/gescor/metadati-protocollo-estesiDTO";
import { MetadatiProtocolloGescorDTO } from "../dto/gescor/metadati-protocollo-gescorDTO";
import { ClassificaGescorVO } from "../vo/gescor/classifica-gescorVO";
import { MapperCreaCorrispondenzaPartenza } from "../mapper/gescor/mapper-crea-corrispondenza-partenza";
import { FormCreaCorrispondenzaPartenzaVO } from "../vo/gescor/form-crea-corrispondenza-partenzaVO";
import { ClassificaDTO } from "../dto/classificaDTO";
import { MapperClassifica } from "../mapper/mapper-classifica";
import { MapperClassificaGescor } from "../mapper/gescor/mapper-classifica-gescor";
import { ClassificaGescorDTO } from "../dto/gescor/classifica-gescorDTO";
import { CorrispondenzaPartenzaGescorDTO } from "../dto/gescor/corrispondenza-partenza-gescorDTO";
import { StatoCorrispondenzaEnum } from "../enum/stato-corrispondenza-enum";

@Injectable({
  providedIn: "root",
})
export class GescorService {
  private urlRicercaAttribuiteGescor =
    env.API_URL_BASE + env.URL_RICERCA_ATTRIBUITE_GESCOR;
  private urlRicercaPartenzeGescor =
    env.API_URL_BASE + env.URL_RICERCA_PARTENZE_GESCOR;
  private urlRicercaPersonaliGescor =
    env.API_URL_BASE + env.URL_RICERCA_PERSONALI_GESCOR;
  private urlGescorCorrispondenza = env.API_URL_BASE + env.URL_GESCOR;
  private urlGescorArrivo = env.API_URL_BASE + env.URL_GESCOR_DETTAGLIO_ARRIVO;
  constructor(
    private httpClient: HttpClient,
    private modaleErroreStore: ModaleErroreStore,
    private mapperAttribuzioni: MapperAttribuzioni,
    private mapperCorrispondenzaArrivo: MapperCorrispondenzaArrivo,
    private mapperCorrispondenzaPartenza: MapperCorrispondenzaPartenza,
    private mapperCreaCorrispondenzaPartenza: MapperCreaCorrispondenzaPartenza,
    private mapperMetadatiCorrispondenza: MapperMetaDatiCorrispondenza,
    private mapperMetadatiProtocollo: MapperMetaDatiProtocolloGescor,
    private baseResponseMapper: MapperBaseResponse,
    private mapperClassifica: MapperClassificaGescor,
    private mapperMetadatiProtocolloGescor: MapperMetaDatiProtocolloGescor
  ) { }

  public ricercaPartenzeGescor(
    page: PaginazioneVO,
    filtro: FiltroRicercaUnitaDocumentarieVO,
    orderBy: string,
    desc: string
  ) {
    let url: string;
    url =
      this.urlRicercaPartenzeGescor +
      "?pageElement=" +
      page.size +
      "&pageNumber=" +
      page.pageNumber +
      "&smistatore=false";

    if (orderBy != null) {
      url = url + "&orderBy=" + orderBy;
    }
    if (desc != null) {
      url = url + "&desc=" + desc;
    }
    const filtroDTO = Object.assign({}, filtro);
    if (filtroDTO.stato == "" || !filtro.stato) {
      filtroDTO.stato = "FASCICOLABILE";
    }

    return this.httpClient
      .post<ResultListDTO<CorrispondenzaPartenzaGescorDTO>>(url, filtroDTO)
      .pipe(
        map(
          (response) => this.getPaginazionePartenze(response, page),
          catchError((err) => {
            this.modaleErroreStore.sendErrore(err);
            return observableThrowError(err); // observable needs to be returned or exception raised
          })
        )
      );
  }

  public ricercaPersonaliGescor(
    page: PaginazioneVO,
    filtro: FiltroRicercaUnitaDocumentarieVO,
    origineArrivo: boolean,
    orderBy: string,
    desc: string
  ) {
    let url: string;
    url =
      this.urlRicercaPersonaliGescor +
      "?origineArrivo=" +
      origineArrivo +
      "&pageElement=" +
      page.size +
      "&pageNumber=" +
      page.pageNumber +
      "&smistatore=false";

    if (orderBy != null) {
      url = url + "&orderBy=" + orderBy;
    }
    if (desc != null) {
      url = url + "&desc=" + desc;
    }
    const filtroDTO = Object.assign({}, filtro);
    if (filtroDTO.stato == "" || !filtro.stato) {
      filtroDTO.stato = "FASCICOLABILE";
    }
    return this.httpClient
      .post<ResultListDTO<AssegnazioneDipendenteDTO>>(url, filtroDTO)
      .pipe(
        map(
          (response) => this.getPaginazionePersonali(response, page),
          catchError((err) => {
            this.modaleErroreStore.sendErrore(err);
            return observableThrowError(err); // observable needs to be returned or exception raised
          })
        )
      );
  }

  public ricercaAttribuiteGescor(
    page: PaginazioneVO,
    filtro: FiltroRicercaUnitaDocumentarieVO,
    orderBy: string,
    desc: string
  ) {
    let url: string;
    url =
      this.urlRicercaAttribuiteGescor +
      "?pageElement=" +
      page.size +
      "&pageNumber=" +
      page.pageNumber;

    if (orderBy != null) {
      url = url + "&orderBy=" + orderBy;
    }
    if (desc != null) {
      url = url + "&desc=" + desc;
    }
    const filtroDTO = Object.assign({}, filtro);

    //  filtroDTO.stato = "ACCETTATA";
    filtroDTO.listaStati = new Array<StatoCorrispondenzaEnum>();
    filtroDTO.listaStati.push(StatoCorrispondenzaEnum.ACCETTATA);
    filtroDTO.listaStati.push(StatoCorrispondenzaEnum.FASCICOLATA);
    return this.httpClient
      .post<ResultListDTO<AttribuzioneDTO>>(url, filtroDTO)
      .pipe(
        map(
          (response) => this.getPaginazioneArrivi(response, page),
          catchError((err) => {
            this.modaleErroreStore.sendErrore(err);
            return observableThrowError(err); // observable needs to be returned or exception raised
          })
        )
      );
  }

  getPaginazionePersonali(
    res: ResultListDTO<AssegnazioneDipendenteDTO>,
    page: PaginazioneVO
  ): ListaPaginataVO<CorrispondenzeGescorVO> {
    // console.log("getPaginazioneUtente", res);
    const pagedData = new ListaPaginataVO<CorrispondenzeGescorVO>();
    const listaVO = new Array<CorrispondenzeGescorVO>();
    res.resultList.forEach((personale) => {
      const corrispondenzaGescor: CorrispondenzeGescorVO = new CorrispondenzeGescorVO();
      corrispondenzaGescor.metadatiProtocolloGescor.anno =
        personale.metadatiCorrispondenza.metadatiProtocollo.anno;
      corrispondenzaGescor.metadatiProtocolloGescor.numero =
        personale.metadatiCorrispondenza.metadatiProtocollo.numero;
      corrispondenzaGescor.metadatiProtocolloGescor.tipo =
        personale.metadatiCorrispondenza.metadatiProtocollo.tipo;
      switch (personale.metadatiCorrispondenza.metadatiProtocollo.tipo) {
        case "ARRIVO_DIGITALE": {
          corrispondenzaGescor.metadatiProtocolloGescor.tipoAbbreviato = "AD";
          break;
        }
        case "ARRIVO_CARTACEO": {
          corrispondenzaGescor.metadatiProtocolloGescor.tipoAbbreviato = "AC";
          break;
        }
        case "PARTENZA_DIGITALE": {
          corrispondenzaGescor.metadatiProtocolloGescor.tipoAbbreviato = "PD";
          break;
        }
        case "PARTENZA_CARTACEO": {
          corrispondenzaGescor.metadatiProtocolloGescor.tipoAbbreviato = "PC";
          break;
        }
        case "INTERNO_CARTACEO": {
          corrispondenzaGescor.metadatiProtocolloGescor.tipoAbbreviato = "IC";
          break;
        }
        case "INTERNO_DIGITALE": {
          corrispondenzaGescor.metadatiProtocolloGescor.tipoAbbreviato = "ID";
          break;
        }
      }
      corrispondenzaGescor.idCorrispondenza = personale.idCorrispondenzaArrivo;

      corrispondenzaGescor.idAttribuzione = personale.id;
      corrispondenzaGescor.oggetto = personale.metadatiCorrispondenza.oggetto;
      listaVO.push(corrispondenzaGescor);
    });
    page.totalElements = res.paginazione.numeroRisTotali;
    page.totalPages = page.totalElements / page.size;
    const start = page.pageNumber * page.size;
    pagedData.page = page;
    pagedData.data = listaVO;
    // console.log("getPaginazione END", pagedData);
    return pagedData;
  }

  getPaginazioneArrivi(
    res: ResultListDTO<AttribuzioneDTO>,
    page: PaginazioneVO
  ): ListaPaginataVO<CorrispondenzeGescorVO> {
    // console.log("getPaginazioneUtente", res);
    const pagedData = new ListaPaginataVO<CorrispondenzeGescorVO>();
    const listaVO = new Array<CorrispondenzeGescorVO>();
    res.resultList.forEach((arrivo) => {
      const arrivoGescor: CorrispondenzeGescorVO = new CorrispondenzeGescorVO();
      /*       if (arrivo.classificaInterna !== null && arrivo.classificaInterna.length > 0) {
        arrivoGescor.classificaAggiuntiva.codice =
        arrivo.classificaInterna[0].livello;
          arrivoGescor.classificaAggiuntiva.nome =
          arrivo.classificaInterna[0].denominazione;
      }
      arrivoGescor.classificaProtocollo.codice = arrivo.classifica.livello;
      arrivoGescor.classificaProtocollo.nome = arrivo.classifica[0].denominazione; */

      arrivoGescor.metadatiProtocolloGescor.anno =
        arrivo.metadatiCorrispondenza.metadatiProtocollo.anno;
      arrivoGescor.metadatiProtocolloGescor.numero =
        arrivo.metadatiCorrispondenza.metadatiProtocollo.numero;
      arrivoGescor.metadatiProtocolloGescor.tipo =
        arrivo.metadatiCorrispondenza.metadatiProtocollo.tipo;
      switch (arrivo.metadatiCorrispondenza.metadatiProtocollo.tipo) {
        case "ARRIVO_DIGITALE": {
          arrivoGescor.metadatiProtocolloGescor.tipoAbbreviato = "AD";
          break;
        }
        case "ARRIVO_CARTACEO": {
          arrivoGescor.metadatiProtocolloGescor.tipoAbbreviato = "AC";
          break;
        }
        case "PARTENZA_DIGITALE": {
          arrivoGescor.metadatiProtocolloGescor.tipoAbbreviato = "PD";
          break;
        }
        case "PARTENZA_CARTACEO": {
          arrivoGescor.metadatiProtocolloGescor.tipoAbbreviato = "PC";
          break;
        }
        case "INTERNO_CARTACEO": {
          arrivoGescor.metadatiProtocolloGescor.tipoAbbreviato = "IC";
          break;
        }
        case "INTERNO_DIGITALE": {
          arrivoGescor.metadatiProtocolloGescor.tipoAbbreviato = "ID";
          break;
        }
      }
      arrivoGescor.idCorrispondenza = arrivo.idSmistamento;
      arrivoGescor.idAttribuzione = arrivo.id;
      arrivoGescor.oggetto = arrivo.metadatiCorrispondenza.oggetto;
      listaVO.push(arrivoGescor);
    });
    page.totalElements = res.paginazione.numeroRisTotali;
    page.totalPages = page.totalElements / page.size;
    const start = page.pageNumber * page.size;
    pagedData.page = page;
    pagedData.data = listaVO;
    // console.log("getPaginazione END", pagedData);
    return pagedData;
  }

  getPaginazionePartenze(
    res: ResultListDTO<CorrispondenzaPartenzaGescorDTO>,
    page: PaginazioneVO
  ): ListaPaginataVO<CorrispondenzeGescorVO> {
    // console.log("getPaginazioneUtente", res);
    const pagedData = new ListaPaginataVO<CorrispondenzeGescorVO>();
    const listaVO = new Array<CorrispondenzeGescorVO>();
    res.resultList.forEach((partenza) => {
      const partenzaDTO: MetadatiProtocolloGescorDTO =
        partenza.metadatiProtocollo;
      const partenzaGescor: CorrispondenzeGescorVO = new CorrispondenzeGescorVO();
      const metadatiCorrispondenzaArrivo: MetadatiCorrispondenzaArrivoVO = new MetadatiCorrispondenzaArrivoVO();
      partenzaGescor.metadatiProtocolloGescor.numero = partenzaDTO.numero;
      partenzaGescor.metadatiProtocolloGescor.anno = partenzaDTO.anno;
      partenzaGescor.metadatiProtocolloGescor.data = partenzaDTO.data;
      partenzaGescor.metadatiProtocolloGescor.tipo = partenzaDTO.tipo;
      if (
        partenza.classificaInterna !== null &&
        partenza.classificaInterna.length > 0
      ) {
        partenzaGescor.classificaAggiuntiva.codice =
          partenza.classificaInterna[0].livello;
        partenzaGescor.classificaAggiuntiva.nome =
          partenza.classificaInterna[0].denominazione;
      }
      partenzaGescor.classificaProtocollo.codice =
        partenza.classifica[0].livello;
      partenzaGescor.classificaProtocollo.nome =
        partenza.classifica[0].denominazione;
      switch (partenzaDTO.tipo) {
        case "ARRIVO_DIGITALE": {
          partenzaGescor.metadatiProtocolloGescor.tipoAbbreviato = "AD";
          break;
        }
        case "ARRIVO_CARTACEO": {
          partenzaGescor.metadatiProtocolloGescor.tipoAbbreviato = "AC";
          break;
        }
        case "PARTENZA_DIGITALE": {
          partenzaGescor.metadatiProtocolloGescor.tipoAbbreviato = "PD";
          break;
        }
        case "PARTENZA_CARTACEO": {
          partenzaGescor.metadatiProtocolloGescor.tipoAbbreviato = "PC";
          break;
        }
        case "INTERNO_CARTACEO": {
          partenzaGescor.metadatiProtocolloGescor.tipoAbbreviato = "IC";
          break;
        }
        case "INTERNO_DIGITALE": {
          partenzaGescor.metadatiProtocolloGescor.tipoAbbreviato = "ID";
          break;
        }
      }
      partenzaGescor.oggetto = partenza.oggetto;
      partenzaGescor.idCorrispondenza = partenza.id;

      listaVO.push(partenzaGescor);
    });

    page.totalElements = res.paginazione.numeroRisTotali;
    page.totalPages = page.totalElements / page.size;
    const start = page.pageNumber * page.size;
    pagedData.page = page;
    pagedData.data = listaVO;
    return pagedData;
  }

  public creaPartenza(
    creaPartenza: FormCreaCorrispondenzaPartenzaVO
  ): Observable<BaseResponseVO> {
    const urlCreaPartenza =
      env.DOCUMENTALE_API_URL_BASE +
      env.API_DOCUMENTALE_FASCICOLO +
      "partenza/";
    return this.httpClient
      .post<BaseResponseDTO>(
        urlCreaPartenza,
        this.mapperCreaCorrispondenzaPartenza.convertVoToDto(creaPartenza)
      )
      .pipe(
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        }),
        map((response: BaseResponseDTO) =>
          this.baseResponseMapper.convertDtoToVo(response)
        )
      );
  }



  getClassifica(
    id: string,
    isArrivo: boolean
  ): Observable<ClassificaGescorVO[]> {
    let url: string = this.urlGescorArrivo + id + "/classifica";
    /*    if (isArrivo) {
         url = this.urlCorrispondenzaArrivo + id + "/classifica";
       } */
    return this.httpClient.get<ClassificaGescorDTO[]>(url).pipe(
      map((response) => this.mapperClassifica.convertListDtoToVo(response)),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  getCorrispondenzaArrivo(id: string): Observable<CorrispondenzaArrivoVO> {
    console.log("[service] getCorrispondenzaArrivo " + id);
    let corrispondenzaArrivoVO;
    const urlCorrispondenzaArrivo =
      env.API_URL_BASE + env.URL_GESCOR_DETTAGLIO_ARRIVO + id;

    return this.httpClient
      .get<CorrispondenzaArrivoDTO>(urlCorrispondenzaArrivo)
      .pipe(
        map(
          (response: CorrispondenzaArrivoDTO) =>
          (corrispondenzaArrivoVO = this.mapperCorrispondenzaArrivo.convertDtoToVo(
            response
          ))
        ),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  getCorrispondenzaArrivoPersonale(
    id: string
  ): Observable<CorrispondenzaArrivoVO> {
    // console.log("[service] getCorrispondenzaArrivo " + id);
    let corrispondenzaArrivoVO;
    const urlCorrispondenzaArrivo =
      env.API_URL_BASE + env.URL_GESCOR_DETTAGLIO_ARRIVO + id + "/personale";

    return this.httpClient
      .get<CorrispondenzaArrivoDTO>(urlCorrispondenzaArrivo)
      .pipe(
        map(
          (response: CorrispondenzaArrivoDTO) =>
          (corrispondenzaArrivoVO = this.mapperCorrispondenzaArrivo.convertDtoToVo(
            response
          ))
        ),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  getCorrispondenzaPartenza(id: string): Observable<CorrispondenzaPartenzaVO> {
    // console.log("[service] getCorrispondenzaArrivo " + id);
    let corrispondenzaPartenzaVO;
    const urlCorrispondenzaPartenza =
      env.API_URL_BASE + env.URL_GESCOR_DETTAGLIO_PARTENZA + id;

    return this.httpClient
      .get<CorrispondenzaPartenzaDTO>(urlCorrispondenzaPartenza)
      .pipe(
        map(
          (response: CorrispondenzaPartenzaDTO) =>
          (corrispondenzaPartenzaVO = this.mapperCorrispondenzaPartenza.convertDtoToVo(
            response
          ))
        ),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  getCopiaConforme(
    idDoc: string,
    idDocummentoPrimario: string,
    metadatiProtocollo: MetadatiProtocolloGescorDTO,
    isPartenza: boolean,
    isPartenzaMista: boolean,
    classifica: ClassificaGescorVO[]
  ): Observable<string> {
    console.log("[CorrispondenzaService.getCopiaConforme] idDoc:", idDoc);
    console.log(
      "[CorrispondenzaService.getCopiaConforme] idDocummentoPrimario:",
      idDocummentoPrimario
    );
    const metadatiProtocolloEstesi = new MetadatiProtocolloEstesiDTO();
    metadatiProtocolloEstesi.idDocumentoPrimario = idDocummentoPrimario;
    metadatiProtocolloEstesi.isPartenza = isPartenza;
    metadatiProtocolloEstesi.isPartenzaMista = isPartenzaMista;
    metadatiProtocolloEstesi.classifica = classifica;
    metadatiProtocolloEstesi.metadatiProtocollo = this.mapperMetadatiProtocolloGescor.convertDtoToVo(
      metadatiProtocollo
    );
    console.log(
      "[CorrispondenzaService.getCopiaConforme] metadatiProtocolloEstesi:",
      metadatiProtocolloEstesi
    );
    console.log(
      "[CorrispondenzaService.getCopiaConforme] metadatiProtocolloEstesiDTO (JSON):",
      JSON.stringify(metadatiProtocolloEstesi)
    );
    let idDocumentoCopiaConforme: string;
    return this.httpClient
      .post<CopiaConformeDTO>(
        this.urlGescorCorrispondenza + idDoc + "/copiaConformeEstesa",
        metadatiProtocolloEstesi
      )
      .pipe(
        map(
          (response) =>
            (idDocumentoCopiaConforme = response.idDocumentoCopiaConforme)
        ),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }
}
